import React, { useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Link from '@material-ui/core/Link';
import Row from 'react-bootstrap/Row';
import styled from 'styled-components';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import axios from 'axios';
import backgroundImg from './assets/background-new.png';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    overflow: 'auto',
  },
  row: {
    height: '100%',
    alignItems: 'center',
  },
  hwLogo: {
    width: '135px',
    height: '135px',
  },
  title: {
    fontWeight: 'bold',
    textAlign: 'center',
    lineHeight: '99.6%',
    letterSpacing: '-0.04rem',
    color: '#6D61AB',
    margin: '20px 0px 25px 0px',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '325px',
      fontSize: 32,
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: '440px',
      fontSize: 36,
    },
  },
  formWrapper: {
    width: '100%',
  },
  label: {
    color: theme.palette.secondary.main,
  },
  login: {
    width: '100%',
    borderRadius: '4px',
    fontSize: 24,
    textTransform: 'none',
    margin: '10px 0px 15px 0px',
  },
  registerCard: {
    marginTop: '20px !important',
  },
  registerTitle: {
    margin: '0',
    fontSize: 24,
    fontWeight: 500,
    lineHeight: '31px',
    letterSpacing: '-0.04rem',
  },
  forgotPassword: {
    color: theme.palette.secondary.main,
    textDecoration: 'underline',
    fontSize: 18,
    marginTop: 11,
    lineHeight: '23px',
    letterSpacing: '-0.04em',
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));

const { Group, Label, Control } = Form;

const PageWrapper = styled.div`
  background: url(${backgroundImg});
  height: 100%;
`;

const Card = styled.div`
  background: #ffffff;
  width: 100%;
  max-width: 550px;
  margin: 0 auto;
  border-radius: 8px;
  height: auto;
  padding-top: 30px;
  padding-bottom: 15px;
  padding-left: 45px;
  padding-right: 45px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Feedback = ({ invalidType }) => {
  return (
    <>
      <Control.Feedback>Looks good!</Control.Feedback>
      <Control.Feedback type="invalid">
        Please provide a valid {invalidType}
      </Control.Feedback>
    </>
  );
};

const ResetPasswordPage = () => {
  const history = useHistory();

  const classes = useStyles();
  const emailRef = useRef(null);
  const passwordRef = useRef(null);
  const passwordConfirmationRef = useRef(null);
  // NO VALIDATION RN ... waiting for design
  const [validated, setValidated] = useState(false);

  const [reset, setReset] = useState({
    password: '',
    passwordConfirmation: '',
  });

  const handleChange = (fieldName) => {
    switch (fieldName) {
      case 'password':
        setReset({
          ...reset,
          password: passwordRef.current.value,
        });
        break;
      case 'passwordConfirmation':
        setReset({
          ...reset,
          passwordConfirmation: passwordConfirmationRef.current.value,
        });
        break;

      default:
        break;
    }
  };

  return (
    <PageWrapper>
      <Container fluid className={classes.root}>
        <Row className={classes.row}>
          <Col xs={0} sm={0} md={1} lg={2} xl={2} />
          <Col>
            <Card>
              <img
                src={require('./assets/hw-logo.png')}
                alt="hw-logo"
                className={classes.hwLogo}
              />
              <p className={classes.title}>
                Hack Western 7 Application Portal Password Reset
              </p>
              <Form
                className={classes.formWrapper}
                noValidate
                validated={validated}
                onSubmit={(event) => {
                  const form = event.currentTarget;

                  if (form.checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                    setValidated(true);
                    return;
                  }
                  setValidated(true);
                  const params = new URLSearchParams(window.location.search);
                  const token = params.get('token');

                  const URI =
                    process.env.NODE_ENV === 'production'
                      ? process.env.REACT_APP_DROPLET_URL +
                        '/api/user/resetPassword'
                      : 'http://localhost:8080/api/user/resetPassword';
                  console.log(URI);
                  axios
                    .post(
                      URI,
                      {
                        email: emailRef.current.value,
                        password: window.btoa(reset.password),
                        token: token,
                      },
                      { withCredentials: true }
                    )
                    .then((response) => {
                      console.log('hello');
                      history.push('/login');
                    })
                    .catch((error) => {
                      console.log(error);
                      console.log(error);
                      if (error.response) {
                        if (error.response.status === 401) {
                          // Invalid email
                        }
                      }
                      // emailRef.current.value = '';
                      passwordRef.current.value = '';
                      passwordConfirmationRef.current.value = '';
                    });
                }}>
                <Group>
                  <Label>
                    <Typography variant="h3" className={classes.label}>
                      Email
                    </Typography>
                  </Label>
                  <Control
                    type="email"
                    placeholder="Enter email"
                    ref={emailRef}
                    required
                  />
                  <Control.Feedback type="invalid">
                    Invalid email
                  </Control.Feedback>
                  <Control.Feedback>Looks good!</Control.Feedback>
                </Group>

                <Form.Row>
                  <Group as={Col} sm={12} md={6}>
                    <Label>
                      <Typography variant="h3" className={classes.label}>
                        New Password
                      </Typography>
                    </Label>
                    <Control
                      required
                      type="password"
                      minLength={8}
                      placeholder="Ex. securepassword"
                      ref={passwordRef}
                      onChange={() => handleChange('password')}
                    />
                    <Feedback invalidType="password" />
                  </Group>
                  <Group as={Col} sm={12} md={6}>
                    <Label>
                      <Typography variant="h3" className={classes.label}>
                        Re-Enter Password
                      </Typography>
                    </Label>
                    <Control
                      required
                      type="password"
                      placeholder="Ex. securepassword"
                      pattern={`^${reset.password}$`}
                      ref={passwordConfirmationRef}
                      onChange={() => handleChange('passwordConfirmation')}
                    />
                    {reset.password !== reset.passwordConfirmation ||
                    reset.passwordConfirmation == '' ? (
                      <Control.Feedback type="invalid">
                        Please make sure your password match
                      </Control.Feedback>
                    ) : (
                      <Control.Feedback>Looks good!</Control.Feedback>
                    )}
                  </Group>
                </Form.Row>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  className={classes.login}>
                  Reset Password
                </Button>
              </Form>
            </Card>
          </Col>
          <Col xs={0} sm={0} md={1} lg={2} xl={2} />
        </Row>
      </Container>
    </PageWrapper>
  );
};

export default ResetPasswordPage;
